<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex ">

            <section class="mu-d-flex mu-flex-row">

                <h1 class="mu-mb-00">Audit history</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
            <section>

            </section>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Administration</li>
                <li>Audit history</li>
                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>

        <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="filterTable()" title="Audit History Filters">
            <div v-if="dataCall" class="spinner-overlay">
                <div class="spinner-background"></div>
                <div class="spinner-flex ">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                        </circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <div v-show="!dataCall">
                <form id="formIdd">
                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container drawer-input">
                    <label class=" mu-mb-00" for="revision">Revision</label>
                    <input type="number" name="revision" min="0" max="999999999" id="revision" ref="revision" @change="revisionRef = $event.target.value" :value="revisionRef">

                </div>
                <div class="flatpickr flatpickrGap mfc-input-wrapper drawer-input">
                    <label for="changeDateId" class=" mu-mb-00">Changed between</label>
                    <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text  flatpickrDiv  ">
                        <input name="changeDate" placeholder="Select Date.." id="changeDateId" class="flatpickrInstance flatpickr" ref="changeDate" block prepend icon="calendar" @change="handleChangeRangeChange($event)" @ready="handleChangeRangeReady()" data-input>
                        <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date">
                            <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                        </button>
                        <div id="mds_text_feedback" class="mfc-invalid-feedback">
                            <mcc-icon name="error" width="24" height="24"></mcc-icon>
                            <span>Please select proper dates.</span>
                        </div>
                    </div>
                </div>

                <div class="mfc-slim-select-wrapper drawer-input">
                    <label for="entities">Entities</label>
                    <select id="entities" @change="entityRef = $event.target.value" name="entity" block>
                        <option data-placeholder="true" value=""></option>
                        <option v-for="(entityName, key) in entityNames" :key="key" :value="entityName">{{
                                                    entityName }}</option>
                    </select>
                </div>
                <div class="mfc-slim-select-wrapper drawer-input">
                    <label for="usernames">Modified by</label>
                    <select id="usernames" @change="modifiedByRef = $event.target.value" :value="modifiedByRef" name="usernames" block>
                        <option data-placeholder="true" value="" :selected="modifiedByRef === ''"></option>
                        <option v-for="(username, key) in modifiedBynames" :selected="modifiedByRef === username" :key="key" :value="username">{{
                                                    username }}
                        </option>
                    </select>
                </div>
            </form>

            </div>
        </Drawer>

        <div class="mcc-col">
            <div style="position:relative">
                <div v-if="!updateCall" class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                            </circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
                <div class="mcc-card">

                    <div class="mcc-card__body">

                                <div class="mu-d-flex mu-justify-content-end mu-pb-06"><button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                        <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Filters {{ filterCount > 0 ? '(' + filterCount + ')' : '' }}</span>
                                    </button>
                                    </div>
                                <mcc-data-table ref="auditHistoryTable" id="auditHistoryTableId"></mcc-data-table>

                    </div>

                </div>
            </div>

        </div>
    </div>

</div>
</template>

<script>
import constantMessages from "../../../messages";
import AuditHistoryAPI from "../../../services/AuditHistoryAPI";
import Utils from "@/script_utils";
import Drawer from '../../common/Drawer.vue';
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
export default {
    name: "AuditHistoryList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["administration.audithistory.list"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            updateDialog: false,
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            changeDateRangeRef: [],
            changeDateBefore: "",
            changeDateAfter: "",
            revisionRef: "",
            revision: "",
            entityRef: "",
            entity: "",
            modifiedByRef: "",
            modifiedBy: "",
            entityNames: {},
            modifiedBynames: {},
            dataCall: true,
            selectInstanceEntities: null,
            selectInstanceUserNames: null,
            tableData: [],
            filterActive: false,
            filterData: [],
            filterCount: 0,
        };
    },
    mounted() {

        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        if (localStorage.getItem("auditList") == "auditList") {
            this.revision = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_revision"
            );
            this.revisionRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_revision"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_revision"
            );

            this.entityRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_entity"
            );
            this.entity = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_entity"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_entity"
            );

            this.modifiedByRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_modifiedBy"
            );
            this.modifiedBy = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_modifiedBy"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_modifiedBy"
            );

            if (localStorage.getItem("DataTables_" + window.location.pathname + "_changeDateRangeRef") != null) {
                let changeDateRangStringArr = localStorage
                    .getItem(
                        "DataTables_" + window.location.pathname + "_changeDateRangeRef"
                    )
                    .split(",");
                if (changeDateRangStringArr.length > 1) {
                    this.changeDateRangeRef[0] = new Date(changeDateRangStringArr[0]);
                    this.changeDateRangeRef[1] = new Date(changeDateRangStringArr[1]);
                }
                this.updateDateRef();
            }

            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_changeDateRangeRef"
            );

            this.currentPageSize = parseInt(
                localStorage.getItem("auditListPageSize")
            );
            localStorage.removeItem("auditListPageSize");

            localStorage.removeItem("auditList");
            this.filterCount = parseInt(
                localStorage.getItem("auditListFilterCount")
            );
            localStorage.removeItem("auditListFilterCount");
        }

        self.initAuditHistoryTable();

        AuditHistoryAPI.getFilterDropdownData()
            .then(result => {
                self.entityNames = result.entityNames;
                self.modifiedBynames = result.modified_by;
                self.dataCall = false;
            })
            .finally(() => {
                this.selectInstanceEntities = new SlimSelect({
                    select: '#entities',

                })
                this.selectInstanceUserNames = new SlimSelect({
                    select: '#usernames',

                })

                this.flatPickr();

            });
    },

    methods: {
        getFilterCount() {
            if (this.revisionRef != "")
                this.filterCount += 1
            if (this.entityRef != "")
                this.filterCount += 1
            if (this.modifiedByRef != "")
                this.filterCount += 1
            if (this.changeDateAfter != "")
                this.filterCount += 1

        },
        resetSlimSelect() {
            this.selectInstanceEntities.setSelected('')
            this.selectInstanceUserNames.setSelected('')
        },
        flatPickr() {
            let self = this;

            self.flatPickerInstance = flatpickr('.flatpickrDiv', {
                dateFormat: 'd/M/Y',
                altInput: true,
                altFormat: 'd/m/Y',
                wrap: true,
                mode: 'range',
                defaultDate: [self.changeDateRangeRef[0], self.changeDateRangeRef[1]],

            })

        },
        filterTable() {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.updateDateRef();
            this.filterCount = 0;
            this.getFilterCount();
            this.revision = this.revisionRef;
            this.entity = this.entityRef;
            this.modifiedBy = this.modifiedByRef;
            this.initAuditHistoryTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")

        },
        updateDateRef() {
            this.changeDateAfter = "";
            this.changeDateBefore = "";
            if (this.changeDateRangeRef.length > 0) {
                let changeDateFrom = this.changeDateRangeRef[0];
                let changeDateTo = this.changeDateRangeRef[1];
                let d = new Date(changeDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.changeDateAfter = d.toISOString();
                if (!changeDateTo) {
                    changeDateTo = changeDateFrom
                }
                d = new Date(changeDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.changeDateBefore = d.toISOString();

            }
        },
        handleChangeRangeChange(e) {
            this.changeDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.changeDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleChangeRangeReady() {
            if (this.changeDateRangeRef.length > 1) {
                this.$refs.changeDate.value =
                    moment(this.changeDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.changeDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        closeDialog() {
            this.$refs.filterDialog.close();
            this.updateDialog = false;
        },
        showDialog() {
            this.updateDialog = true;
        },
        showFilterDialog() {
            this.$refs.filterDialog.show();
            this.showDialog();
        },
        resetFilter() {
            this.updateCall = false;
            this.filterCount = 0;
            this.changeDateRangeRef = [];
            this.changeDateBefore = "";
            this.changeDateAfter = "";
            this.revisionRef = "";
            this.revision = "";
            this.entityRef = "";
            this.entity = "";
            this.resetSlimSelect();
            flatpickr("#changeDateId").destroy();
            this.flatPickr();
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initAuditHistoryTable();
        },
        updateTemplate() {
            let self = this;

            this.$refs.auditHistoryTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            let revisionDate = $(targetEle).attr("data-date");
                            let date = new Date(revisionDate.substring(0, revisionDate.indexOf("+")) + "Z").toLocaleString("en-GB").replace(/\,/g, '');
                            let user = $(targetEle).attr("data-user");

                            self.$router.push(
                                self.CONTEXT_PATH + "/admin/audit/revision/" + reference.trim() + "?modifiedByUser=" + user + "&revisionDate=" + encodeURI(date)
                            );
                        }
                    });
                });

            $(".revisionDate").each((a, obj) => {
                let revisionDate = $(obj)[0].innerText;
                let htmlTag = "";
                if (revisionDate != "null") {
                    htmlTag += '<span>' +
                        new Date(revisionDate.substring(
                                0, revisionDate
                                .indexOf("+")) +
                            "Z").toLocaleString("en-GB")
                        .replace(/\,/g, '') +
                        '</span>';
                }
                $(obj).html(htmlTag);
                $(obj).removeClass("d-none");
            });

            $(".entityList").each((a, obj) => {
                let text1 = $(obj)
                    .text()
                    .split(",");
                let htmlTag = "";
                text1.forEach((b, index) => {
                    if (b != "") {
                        if (index == 0) {
                            htmlTag += '<a class="table-link">' + b + "</a>";
                        } else {
                            htmlTag += ', <a class="table-link">' + b + "</a>";
                        }
                    }
                });
                $(obj).html(htmlTag);
                $(obj).removeClass("d-none");
            });

            this.$refs.auditHistoryTable
                .querySelectorAll('td [class="table-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).text();
                            self.$router.push(
                                self.CONTEXT_PATH + '/admin/audit/entityHistory/' + reference.trim()
                            );
                        }
                    });
                });
        },
        initAuditHistoryTable() {
            let self = this;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const table = document.getElementById("auditHistoryTableId");
            self.tableObj = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No audit history found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                fixedHeight: true,
                schema: {
                    properties: {
                        revisionNumber: {
                            type: "string",
                            title: "Revision",
                            sortable: true,
                            template: '<a class="name-link" data-id="{{revisionNumber}}" data-date="{{revisionDate}}" data-user="{{modifiedByUser}}">{{revisionNumber}}</a>',
                            columnSearch: false
                        },
                        revisionDate: {
                            type: "string",
                            title: "Date",
                            sortable: true,
                            template: '<div class="revisionDate d-none">{{revisionDate}}<div>',
                            columnSearch: false
                        },
                        entityList: {
                            type: "string",
                            title: "Entity",
                            template: '<div class="entityList d-none">{{entityList}}</div>',
                            sortable: false,
                            columnSearch: false
                        },
                        modifiedByUser: {
                            type: "string",
                            title: "User",
                            sortable: true,
                            columnSearch: false
                        },
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {

                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        let sortName;
                        if (sortHeader == null || sortHeader == "revisionNumber" || sortHeader == "revisionDate") {
                            sortName = "timestamp";
                        } else if (sortHeader == "modifiedByUser") {
                            sortName = "username";
                        }
                        if (sortDirection == null) {
                            sortDirection = "desc";
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortName +
                            "&dir=" +
                            sortDirection +
                            "&revision=" +
                            self.revision +
                            "&entityName=" +
                            self.entity +
                            "&username=" +
                            encodeURI(self.modifiedBy);
                        if (self.changeDateAfter != "") {
                            queryString +=
                                "&startDate=" +
                                self.changeDateAfter +
                                "&endDate=" +
                                this.changeDateBefore;
                        }

                        return AuditHistoryAPI.getAuditHistory(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }
                            self.updateCall = true;
                            self.tableData = responseData.data;
                            return responseData;
                        });

                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;

                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("auditListPageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_revision",
                this.revision
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_entity",
                this.entity
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_modifiedBy",
                this.modifiedBy
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_changeDateRangeRef",
                this.changeDateRangeRef
            );
            localStorage.setItem("auditListFilterCount", this.filterCount);
        }
    }
};
</script>

<style scoped>
.mfc-slim-select-wrapper label {
    margin-bottom: 0px;
}

.mfc-input-group input[readonly] {
    background-color: #e9ecef;
    opacity: 1;
}

.flatpickrGap {
    gap: 0.25rem;
}
</style>
